'use client';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, isValidElement } from 'react';
import { useFieldContext } from './FieldContext';
/**
 * Compound member of <Field>. Slot wrapper that injects id and ARIA attributes
 * from FieldContext into its single child element. Used in the 10% slot
 * decomposition case when you need manual composition.
 *
 * <Field>
 *   <Field.Label>Email</Field.Label>
 *   <Field.Control><Input type="email" /></Field.Control>
 *   <Field.Description>We'll never share it.</Field.Description>
 *   <Field.Error>{errors.email}</Field.Error>
 * </Field>
 */
export function FieldControl({ children }) {
    const ctx = useFieldContext();
    if (!ctx)
        return _jsx(_Fragment, { children: children });
    const child = Children.only(children);
    if (!isValidElement(child))
        return _jsx(_Fragment, { children: children });
    const describedByParts = [
        ctx.descriptionId,
        ctx.errorId,
    ].filter(Boolean);
    return cloneElement(child, {
        id: ctx.fieldId,
        'aria-describedby': describedByParts.length > 0 ? describedByParts.join(' ') : undefined,
        'aria-invalid': ctx.hasError ? true : undefined,
        'aria-required': ctx.required ? true : undefined,
    });
}
//# sourceMappingURL=FieldControl.js.map